/** @typedef {{ nl: string, en: string }} LocalizedPaths */

/** @typedef {{ pageId: string, paths: LocalizedPaths, path: string }} GuideRoute */

/** @type {GuideRoute[]} */
export const GUIDE_ROUTES = [
  {
    pageId: "how",
    paths: {
      nl: "/handleiding/hoe-het-werkt",
      en: "/en/guide/how-it-works",
    },
    path: "/handleiding/hoe-het-werkt",
  },
  {
    pageId: "werkplanExport",
    paths: {
      nl: "/handleiding/werkplan-printen",
      en: "/en/guide/print-work-plan",
    },
    path: "/handleiding/werkplan-printen",
  },
  {
    pageId: "cutSimulator",
    paths: {
      nl: "/handleiding/zaagvolgorde-controleren",
      en: "/en/guide/review-cut-sequence",
    },
    path: "/handleiding/zaagvolgorde-controleren",
  },
  {
    pageId: "importExport",
    paths: {
      nl: "/handleiding/importeren-exporteren",
      en: "/en/guide/import-export",
    },
    path: "/handleiding/importeren-exporteren",
  },
];
